import { DocumentationItemHeaderV2 } from "@supernova-studio/model";
import { DTODocumentationItemConfigurationV2 } from "../../api/dto/elements/documentation/item-configuration-v2";
import { z } from "zod";
//
// Types
//
export const DTODocumentationPageRoomHeaderData = z.object({
    title: z.string(),
    configuration: DTODocumentationItemConfigurationV2,
});
export const DTODocumentationPageRoomHeaderDataUpdate = z.object({
    title: z.string().optional(),
    configuration: DTODocumentationItemConfigurationV2.omit({ header: true })
        .extend({ header: DocumentationItemHeaderV2.partial() })
        .optional(),
});
//
// YJS Bindings
//
export function itemConfigurationToYjs(yDoc, item) {
    yDoc.transact((trx) => {
        const { title, configuration } = item;
        const header = configuration === null || configuration === void 0 ? void 0 : configuration.header;
        if (title !== undefined) {
            const headerYMap = trx.doc.getMap("itemTitle");
            headerYMap.set("title", title);
        }
        if (header) {
            const headerYMap = trx.doc.getMap("itemHeader");
            header.description !== undefined &&
                headerYMap.set("description", header.description);
            header.alignment !== undefined &&
                headerYMap.set("alignment", header.alignment);
            header.foregroundColor !== undefined &&
                headerYMap.set("foregroundColor", header.foregroundColor);
            header.backgroundColor !== undefined &&
                headerYMap.set("backgroundColor", header.backgroundColor);
            header.backgroundImageAsset !== undefined &&
                headerYMap.set("backgroundImageAsset", header.backgroundImageAsset);
            header.backgroundImageScaleType !== undefined &&
                headerYMap.set("backgroundImageScaleType", header.backgroundImageScaleType);
            header.showBackgroundOverlay !== undefined &&
                headerYMap.set("showBackgroundOverlay", header.showBackgroundOverlay);
            header.showCoverText !== undefined &&
                headerYMap.set("showCoverText", header.showCoverText);
            header.minHeight !== undefined &&
                headerYMap.set("minHeight", header.minHeight);
        }
        const configYMap = trx.doc.getMap("itemConfiguration");
        (configuration === null || configuration === void 0 ? void 0 : configuration.showSidebar) !== undefined &&
            configYMap.set("showSidebar", configuration.showSidebar);
        (configuration === null || configuration === void 0 ? void 0 : configuration.isHidden) !== undefined &&
            configYMap.set("isHidden", configuration.isHidden);
        (configuration === null || configuration === void 0 ? void 0 : configuration.isPrivate) !== undefined &&
            configYMap.set("isPrivate", configuration.isPrivate);
    });
}
